import React from 'react';
import RelatedContentList from '../RelatedContentList';
import { ItemStyle } from '../RelatedContentList/definitions';
import { AttributeType } from '_utils/helpers/attributeType';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

function transformItem(item, primaryCategory) {
  const { id, title, strapline, permalink, updatedAt, publishDate, image, imageAlt } = item || {};

  let attributes = [];

  if (updatedAt) {
    attributes.push({
      type: AttributeType.newsDate,
      value: updatedAt
    });
  }

  return {
    id,
    title,
    description: strapline,
    primaryCategory,
    image: {
      value: {
        src: image,
        alt: imageAlt
      }
    },
    link: {
      url: permalink,
      type: 'External',
      target: '_blank'
    },
    attributes
  };
}

/**
 * Wrapper for RelatedContentList with a data transform
 * @param props
 */
function NewsRelatedContent(props) {
  const { rendering } = props;

  const fields = rendering?.fields?.data?.datasource;

  const [t] = useTranslation();

  let remappedItems = [];

  let primaryCategory = t('news-primary-category');

  if (fields?.items) {
    remappedItems = fields.items.map((item) => transformItem(item, primaryCategory));
  }

  return (
    <RelatedContentList
      fieldsOverride={{ ...fields, items: remappedItems }}
      paramsOverride={{ theme: ItemStyle.listingWithImageAndDescription }}
    />
  );
}

NewsRelatedContent.propTypes = {
  rendering: PropTypes.shape({
    fields: PropTypes.shape({
      data: PropTypes.shape({
        datasource: PropTypes.shape({
          items: PropTypes.arrayOf(PropTypes.object),
        }),
      }),
    }),
  }),
};

export default NewsRelatedContent;
